import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './routes';
import './App.css'
import {Provider} from 'react-redux'
import store from './store/index'

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <Routes />
    </React.StrictMode>
  </Provider>,
  document.getElementById('root')
);